import React from 'react';
import { Box, Typography } from '@mui/material';
import { StyledButton, ButtonContainer, Container } from '../pages/Questionnaire/styles';

export default function TestEndView({ payload, onNext }) {
  const { testName } = payload;
  return (
    <Container style={{ zIndex: 500 }}>
      <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        <Typography variant="h4" align="center" gutterBottom>
          המבחן נגמר
        </Typography>

        <Typography variant="body1" align="center" style={{ direction: "rtl" }} paragraph>
          סיימת את המבחן ״{testName}״
        </Typography>
      </Box>

      <ButtonContainer style={{ justifyContent: 'center', marginTop: 'auto' }}>
        <StyledButton variant="contained" onClick={() => onNext()}>
          המשך למבחן הבא
        </StyledButton>
      </ButtonContainer>
    </Container>
  );
}
